import React, {Component, Fragment} from 'react';
import {Subject, forkJoin} from 'rxjs';
import {Translate} from 'app/services/translate';
import {Points} from './points.service';
import {Positions} from './positions.service';
import {Map} from './map/map';
import {Container as ButtonsContainer} from './buttons/container';
import {Search} from './search/search';
import {MapPosition} from 'app/model/mapPosition';

export class AgentsMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            points: [],
            cities: [],
            map: null,
            searchBox: null,
        };

        this.points = new Points();
        this.positions = new Positions();

        forkJoin(
            this.points.points$(),
            this.positions.popularCities$(),
            this.positions.initialMapSettings$()
        ).subscribe(this.initialValuesSubscriber.bind(this));

        this.onPointSelect$ = new Subject();
        this.onMarkerClick$ = new Subject();
        this.onCityButtonClick$ = new Subject();
        this.onGeolocationButtonClick$ = new Subject();
        this.onMapPositionChange$ = new Subject();

        this.onPointSelect$.subscribe(this.pointSelectSubscriber.bind(this));
        this.onMarkerClick$.subscribe(this.markerClickSubscriber.bind(this));
        this.onCityButtonClick$.subscribe(this.cityClickSubscriber.bind(this));
        this.onGeolocationButtonClick$.subscribe(this.geolocationClickSubscriber.bind(this));
        this.onMapPositionChange$.subscribe(this.mapPositionSubscriber.bind(this));
    }

    initialValuesSubscriber([points, cities, mapSettings]) {
        this.setState({
            points,
            cities,
            mapPosition: mapSettings.position,
            defaultZoom: mapSettings.zoom,
            loading: false
        })
    }

    pointSelectSubscriber(mapPosition) {
        if (!mapPosition) {
            return;
        }

        const point = this.points.getPointByLocation(this.state.points, mapPosition);

        this.setState({
            mapPosition,
            points: this.points.markPointAsVisible(this.state.points, point)
        });
    }

    markerClickSubscriber(point) {
        if (!this.state.points || this.state.loading) {
            return;
        }

        this.setState({
            points: point.visible ?
                this.points.markPointsAsInvisible(this.state.points) :
                this.points.markPointAsVisible(this.state.points, point),
        });
    }

    cityClickSubscriber({mapPosition}) {
        if (!mapPosition) {
            return;
        }

        this.setState({mapPosition});
    }

    geolocationClickSubscriber() {
        if (!navigator.geolocation) {
            return;
        }

        return navigator.geolocation.getCurrentPosition(({coords}) => {
            this.setState({
                mapPosition: new MapPosition(this.state.defaultZoom, {
                    lat: coords.latitude,
                    lng: coords.longitude,
                }),
            });
        });
    }

    mapPositionSubscriber(position) {
        if (!position) {
            return;
        }

        this.setState({
            mapPosition: position,
        })
    }

    render() {
        return (
            <div>
                {!this.state.loading && this.state.points.length > 0 &&
                    <Fragment>
                        <Search
                            points={this.state.points}
                            handlePointSelect$={this.onPointSelect$}
                            handleGeolocationButtonClick$={this.onGeolocationButtonClick$}
                            zoom={this.state.defaultZoom}/>
                        <ButtonsContainer
                            handleCitiesButtonClick$={this.onCityButtonClick$}
                            cities={this.state.cities}/>
                        <Map
                            apiKey={window.agentsMap.key}
                            points={this.state.points}
                            position={this.state.mapPosition}
                            pointCenteredZoom={this.state.defaultZoom}
                            handleMarkerClick$={this.onMarkerClick$}
                            handleMapPositionChange$={this.onMapPositionChange$}/>
                    </Fragment>
                }
                {!this.state.loading && this.state.points.length === 0 &&
                    <span>{Translate('commons_agents_map_agents_not_found')}</span>
                }
                {this.state.loading && <div className="sk-circle places-loading"/>}
            </div>
        );
    }
}
